import { v1 } from "uuid"
const uuid = { v1 }
import { getAttrById } from "utils"

class SubPageEventControl {
  constructor(vue) {
    this.context = vue
  }
  /**
   * @param {string} innerElement 组件的类型
   * 将组件中的this,保存到事件功能的内部中,便于事件触发时获取组件变量、响应和触发组件的this、触发组件数据更新等,需要用到this的逻辑
   */
  bindContext(innerElement) {
    this.context.$subPageEvent.addContext(this.context.businessId, innerElement, this.context)
  }
  /**
   * @param {string} innerElement 组件的类型
   * 删除组件中的this
   */
  removeContext(innerElement) {
    this.context.$subPageEvent.removeContext(this.context.businessId, innerElement)
  }
  //初始化
  init(innerElement) {
    this.bindContext(innerElement) //存储组件this
    // 同时将businessId保存到组件options中
    this.context.$changeOptionsEV(
      this.context.businessId,
      "businessId",
      false,
      null,
      this.context.myid,
      true
    )
  }
}

export default {
  data() {
    return {
      businessId: uuid.v1(),
      subPageEventControl: new SubPageEventControl(this)
    }
  },
  mounted() {
    // 如果当前组件包含appId，说明不参与业务事件
    // if (this.options.appId) return
    // 含有页面插件的页面才初始化业务事件功能
    let innerElement = this.options.innerElement
    if (this.options.pluginName?.includes("ListPageSearchComponentPlugin")) {
      innerElement = "cxSearch"
    }
    if (this.$store.state[this.request_prefix].page.pluginName?.includes("listPagePlugin")) {
      this.subPageEventControl.init(innerElement)
      setTimeout(() => {
        this.$eventBus.$emit("listPage-component-init", {
          businessId: this.options.businessId,
          type: innerElement
        })
      }, 1000)
    }
    if (this.$store.state[this.request_prefix].page.pluginName?.includes("detailPagePlugin")) {
      this.subPageEventControl.init(innerElement)
      setTimeout(() => {
        this.$eventBus.$emit("detailPage-component-init", {
          businessId: this.options.businessId,
          type: innerElement
        })
      }, 1000)
    }
    if (this.$store.state[this.request_prefix].page.pluginName?.includes("subPagePlugin")) {
      if (innerElement === "emptyLayoutComponent" && this.options.pluginName.includes("dataGridPlugin")) {
        innerElement = "cxDataGrid"
      }
      this.subPageEventControl.init(innerElement)
      setTimeout(() => {
        this.$eventBus.$emit("subPage-component-init", {
          type: innerElement + '_' + this.options.businessId
        })
      }, 1000)
    }
  },
  beforeDestroy() {
    let innerElement = this.options.innerElement
    if (this.options.pluginName?.includes("ListPageSearchComponentPlugin")) {
      innerElement = "cxSearch"
    }
    this.$subPageEvent.removeContext(this.options.businessId, innerElement)
  }
}
